import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'lib-flexible'

import api from './api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import * as utils from '@/assets'

import iView from 'iview'
require('../static/animate.css');
require('../static/font/iconfont.css');
require('../static/font/iconfont.js');
// require('../static/dox-preview.js');

Vue.use(ElementUI);

Vue.use(iView)
// 注册名为 change 的指令
// Vue.directive("change", directive);
Vue.use(VueAxios, axios)

Vue.config.productionTip = false
// Vue.use(VuePrlx.VuePrlxPlugin);


// Vue.prototype.$utils = utils
// 接口引入
Vue.prototype.$api = api
// Vue.mixin(mixin)


Vue.prototype.$eventBus = new Vue()
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})